export const PLAYLIST_ACTIONS_MENU = [
    {
        icon: 'fullscreen',
        label: 'Fullscreen',
    },
    {
        icon: 'quick-move',
        label: 'Quick move',
    },
    {
        icon: 'swap-content',
        label: 'Swap content',
    },
    {
        icon: 'settings',
        label: 'Settings',
    },
    {
        icon: 'remove',
        label: 'Remove',
    },
];
